import { Currency, getCurrencyByPurchaseCountry } from '@nemuru-eng/js-api-client';
import { getAgentConfigurationFromCdnByAgentId } from '@nemuru-eng/js-api-client/slim';

export const getFirstPurchaseCountryCurrencyByAgentId = async (agentId: string): Promise<Currency> => {
  try {
    const agentConfiguration = await getAgentConfigurationFromCdnByAgentId({ agentId });
    return getCurrencyByPurchaseCountry(agentConfiguration.allowedPurchaseCountries[0]);
  } catch (e) {
    console.error(e);
    return Currency.EUR;
  }
};
